import React from 'react';
import { BaseConfigProps, commonStyles, httpMethods } from '../shared/ConfigFormHelpers';

const WebhookTriggerConfig: React.FC<BaseConfigProps> = ({ node, updateConfig }) => {
  return (
    <div className="space-y-3">
      <div>
        <label className={commonStyles.label}>
          HTTP Metódus
        </label>
        <select
          value={node.data.config.method || 'POST'}
          onChange={(e) => updateConfig('method', e.target.value)}
          className={commonStyles.select}
        >
          {httpMethods.map((method) => (
            <option key={method.value} value={method.value}>
              {method.label}
            </option>
          ))}
        </select>
      </div>
      
      <div>
        <label className={commonStyles.label}>
          Webhook útvonal
        </label>
        <input
          type="text"
          value={node.data.config.path || '/webhook'}
          onChange={(e) => updateConfig('path', e.target.value)}
          className={commonStyles.input}
          placeholder="/api/webhook/my-endpoint"
        />
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          Az útvonal ahol a webhook fogadásra kerül
        </p>
      </div>
    </div>
  );
};

export default WebhookTriggerConfig;
